<div class="row">
  <div class="col-12 mb-2">
    <div>
      <div class="row mb-2">
        <div class="col-xl-8 col-md-12">
          <div class="d-flex align-items-baseline">
            <label class="form-check-label me-2 required-star form-label" for="">
              {{ title ? title : ("common.phone-numbers" | translate) }}
            </label>
            <div
              *ngIf="isSubmit && (form.controls['contacts'].errors?.['missingPhone'] || form.controls['contacts'].errors?.['required'])"
              class="required">
              {{ 'definition.staff.phone-req' | translate }}
            </div>
          </div>

        </div>
        <div class="col-xl-4 col-md-12 right-end"  *ngIf="!isReadOnly">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs ms-2"
            (click)="newHeadItem()"
          >
            <i class="fas fa-add"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs ms-2"
            *ngIf="showSearchIcon"
            (click)="onClickSearchIcon()"
          >
            <i class="fas fa-search"></i>
          </button>
           <span *ngIf="showSearchIcon && (patientPhones ?? 0) > 0" class="custom-badge">
            {{patientPhones}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 mb-2" *ngIf="newPhoneItem">
    <div class="card p-3 mb-2">
      <div class="row mb-2 text-center">
        <div [ngClass]="prefixValue ? 'col-xl-3' : 'col-xl-4'">
          <p-dropdown
            [options]="types"
            placeholder="{{ 'general.title' | translate }}"
            [(ngModel)]="newPhoneData.type"
            optionLabel="label"
            appendTo="body"
          >
          </p-dropdown>
        </div>
        <div class="col-xl-3" *ngIf="prefixValue">
          <p-dropdown
            [options]="countries"
            [(ngModel)]="newPhoneData.prefixValue"
            [filter]="true"
            filterBy="name"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
          >
            <ng-template let-country pTemplate="item">
              <div class="country-option d-flex align-items-center">
                <div [innerHtml]="country.flag | safeHtml"></div>
                <span>{{ country.label }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div [ngClass]="prefixValue ? 'col-xl-4' : 'col-xl-4'">
          <input
           #phoneInput
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="newPhoneData.phone"
            placeholder="{{ 'shared-components.phone' | translate }}"
            required
            [mask]="newPhoneData?.prefixValue === '+90' ? '(000) 000 0000' : ''"
          />
        </div>
        <div [ngClass]="prefixValue ? 'col-xl-2' : 'col-xl-2'">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="newPhoneData.priority"
            aria-checked="true"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-xl-10 col-sm-12" *ngIf="showDescriptionInput">
          <input
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="newPhoneData.description"
            placeholder="{{ 'shared-components.description' | translate }}"
            maxlength="100"
          />
        </div>
        <div [ngClass]="showDescriptionInput ? 'col-xl-2' : 'col-xl-12'" class="right-end">
          <button
            class="btn btn-sm btn-primary"
            (click)="add()"
            *ngIf="!isReadOnly"
            [disabled]="!isAddValid()"
          >
            {{ "general.add" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Existing Items -->
  <div
    class="col-12"
    *ngFor="let item of phoneItems; let i = index; trackBy: trackByFn"
  >
    <div class="card p-3" style="margin-bottom: 1.25%;margin-top: 0px;   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
"
         *ngIf="editingIndex !== i; else editingRow">
      <div class="row">
        <div class="col-xl-1">
          <i class="fa fa-star" [ngStyle]="{ 'color': item?.priority? 'blue' : 'gray' }" style="color: blue"></i>
        </div>
        <div class="col-xl-5">

          <app-call-button *ngIf="item?.phone" [class]="'btn btn-success p-1 pt-0 pb-0'"
                           [phone]="item?.phone"></app-call-button>
           {{ prefixValue ? (item?.prefixValue + item?.phone | phoneMask) : (item?.prefixValue + item?.phone | phoneMask) }}
        </div>

        <div class="col-xl-3">
          {{ item?.type?.label || item?.type?.value?.label }}
        </div>
        <div class="col-xl-3 text-end" *ngIf="!isReadOnly">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs me-1"
            (click)="edit(item, i)"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-icon-xxs"
            (click)="deleteItem(i)"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-xl-12" *ngIf="showDescriptionInput">
          {{ item?.description }}
        </div>
      </div>
    </div>

    <ng-template class="card p-3" #editingRow>
      <div class="card p-3 mb-2">
        <div class="row align-items-center mb-2">
          <div [ngClass]="prefixValue ? 'col-xl-3' : 'col-xl-4'">
            <p-dropdown
              [options]="types"
              placeholder="{{ 'general.title' | translate }}"
              [(ngModel)]="selectedRow.type"
              optionLabel="label"
              appendTo="body"
            >
            </p-dropdown>
          </div>
          <div class="col-xl-3" *ngIf="prefixValue">
            <p-dropdown
              [options]="countries"
              [(ngModel)]="selectedRow.prefixValue"
              [filter]="true"
              filterBy="name"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            >
              <ng-template let-country pTemplate="item">
                <div class="country-option d-flex align-items-center">
                  <div [innerHtml]="country.flag | safeHtml"></div>
                  <span>{{ country.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div [ngClass]="prefixValue ? 'col-xl-4' : 'col-xl-4'">
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="selectedRow.phone"
              placeholder="{{ 'shared-components.phone' | translate }}"
              [mask]="selectedRow?.prefixValue === '+90' ? '(000) 000 0000' : ''"
              required
              appPreventNegativeInput
            />
          </div>
          <div [ngClass]="prefixValue ? 'col-xl-2' : 'col-xl-2'">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              [(ngModel)]="selectedRow.priority"
              aria-checked="true"
            />
          </div>
        </div>
        <div class="row">
          <div
            *ngIf="showDescriptionInput"
            class="col-xl-10 col-sm-12 text-center"
          >
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="selectedRow.description"
              placeholder="{{ 'shared-components.description' | translate }}"
              minlength="10"
              maxlength="100"
            />
          </div>
          <div [ngClass]="showDescriptionInput ? 'col-xl-2' : 'col-xl-12'" class="right-end">
            <button
              class="btn btn-sm btn-warning me-1"
              (click)="saveItem()"
              [disabled]="!isPhoneValid(selectedRow.prefixValue,selectedRow.phone)"
            >
              <i class="fas fa-save"></i>
            </button>
            <button class="btn btn-sm btn-danger" (click)="cancel()">
              <i class="fas fa-close"></i>
            </button>
          </div>

        </div>

      </div>
    </ng-template>
  </div>
</div>
